import { render, staticRenderFns } from "./managementLabel.vue?vue&type=template&id=09f68fc5&scoped=true"
import script from "./managementLabel.vue?vue&type=script&lang=js"
export * from "./managementLabel.vue?vue&type=script&lang=js"
import style0 from "./managementLabel.vue?vue&type=style&index=0&id=09f68fc5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f68fc5",
  null
  
)

export default component.exports